import fetchWithTimeout from './fetchAPI';
import { log } from '../Log.init'

export async function createClient(token, client) {    
    const body = {
                "logo" : typeof client.company.logo === 'string' ? client.company.logo : '',
                "name" : client.company.name,
                "start_date" : client.company.startDate,
                "end_date" : client.company.endDate,
                "billing_contact" : {
                    "full_name" : client.billing.name,
                    "phone_number" : client.billing.phone,
                    "email_address" : client.billing.email},
                "administrative_contact" : {
                    "full_name" : client.administrator.name,
                    "phone_number" : client.administrator.phone,
                    "email_address" : client.administrator.email    
                },
                "production_environments" : client.environments.productionCount,
                "test_environments" : client.environments.testCount
            };

    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('token', token);

    const results = await fetchWithTimeout('client',
                                            {method: 'POST',
                                                headers: headers,
                                                body: JSON.stringify(body),
                                                cache: 'no-cache',
                                                redirect: 'follow',
                                                credentials: 'omit'
                                            }, 3000);
    const jsonResults = await results.json();
    return (mapResponse(jsonResults));
}

export async function getClient(token, clientId) {
    const headers = new Headers();
    headers.append('token', token);
    const path = 'client/' + clientId;
    const results = await fetchWithTimeout(path,
        {method: 'GET',
            headers: headers,
            cache: 'no-cache',
            redirect: 'follow',
            credentials: 'omit'
        }, 3000);

    const jsonResults = await results.json();
    return (mapResponse(jsonResults));
}

export async function getTenantClient(token) {
    const headers = new Headers();
    headers.append('token', token);
    const path = 'tenantclient';
    const results = await fetchWithTimeout(path,
        {method: 'GET',
            headers: headers,
            cache: 'no-cache',
            redirect: 'follow',
            credentials: 'omit'
        }, 3000);

    const jsonResults = await results.json();
    return (mapResponse(jsonResults));
}

export async function getClients(token) {
    const headers = new Headers();
    headers.append('token', token);
    const results = await fetchWithTimeout('client',
        {method: 'GET',
            headers: headers,
            cache: 'no-cache',
            redirect: 'follow',
            credentials: 'omit'
        }, 8000);

    const jsonResults = await results.json();
    return (mapResponse(jsonResults));
}

export async function getClientStats(token) {
    const headers = new Headers();
    headers.append('token', token);
    const results = await fetchWithTimeout('clientstats',
        {method: 'GET',
            headers: headers,
            cache: 'no-cache',
            redirect: 'follow',
            credentials: 'omit'
        }, 8000);
     log.info({message: `getClientStats: jsonResults = ${JSON.stringify(results)}`});
    const jsonResults = await results.json();

    return (jsonResults);
}

export async function getClientTenants(token, clientId) {
  const headers = new Headers();
  headers.append('token', token);
  const path = 'clienttenants/' + clientId;
  const results = await fetchWithTimeout(path,
      {method: 'GET',
          headers: headers,
          cache: 'no-cache',
          redirect: 'follow',
          credentials: 'omit'
      }, 5000);

  const jsonResults = await results.json();
  return (mapResponse(jsonResults));
}

export async function updateClient(token, client) {
  const headers = new Headers();
  headers.append('token', token);
  headers.append('Content-Type', 'application/json');
  const body = mapRequest(client)
  const results = await fetchWithTimeout('client',
      {method: 'PUT',
          headers: headers,
          body: JSON.stringify(body),
          cache: 'no-cache',
          redirect: 'follow',
          credentials: 'omit'
      }, 3000);

  const jsonResults = await results.json();
  return (mapResponse(jsonResults));
}

export async function updateClientTenant(token, tenant) {
  const headers = new Headers();
  headers.append('token', token);
  headers.append('Content-Type', 'application/json');
  const body = mapRequest(tenant);
  const results = await fetchWithTimeout('clienttenant',
      {method: 'PUT',
          headers: headers,
          body: JSON.stringify(body),
          cache: 'no-cache',
          redirect: 'follow',
          credentials: 'omit'
      }, 3000);

  const jsonResults = await results.json();
  return (mapResponse(jsonResults));
}

export async function addClientTenant(token, tenant) {
  const headers = new Headers();
  headers.append('token', token);
  headers.append('Content-Type', 'application/json');
  const body = mapRequest(tenant);
  const results = await fetchWithTimeout('clienttenant',
      {method: 'POST',
          headers: headers,
          body: JSON.stringify(body),
          cache: 'no-cache',
          redirect: 'follow',
          credentials: 'omit'
      }, 3000);

  const jsonResults = await results.json();
  return (mapResponse(jsonResults));
}

function mapRequest(body) {
    let request = {...body};
    if (body.clientId)  
        request.client_id = body.clientId;
    if (body.tenantId)  
        request.tenant_id = body.tenantId;
    return request;
}

function  mapResponse(results) {
    let response = null;
    if (results instanceof Array) {
        response = [];
        results.forEach(tenant => response.push(mapTenant(tenant)));
    } else {
        response = mapTenant(results);
    }
    return response;
  }

  function mapTenant(tenant) {
    let tenantData = {...tenant};
    if (tenant.client_id)
        tenantData.clientId = tenant.client_id;
    if (tenant.tenant_id)
        tenantData.tenantId = tenant.tenant_id;

    return tenantData;
  }
